import type { FaireProductEntity } from "../../entity_types/product";

export const p_2uz5b9at8y: FaireProductEntity = {
  token: "p_2uz5b9at8y",
  type: "product",
  name: "Newborn Knotted Gown - Jo",
  brandToken: "b_qba2f8n5gh",
  brandName: "Copper Pearl",
  imageUrl:
    "https://cdn.faire.com/fastly/73daab9344376eea14040744ec971395709ab0a83ded02499685b79f0a7fbcea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff0275053d5b908a73732e399d0ad6df2a27108f69463a1b26b1c8cf9436eeaf.jpeg",
    "https://cdn.faire.com/fastly/8bc74911e580c9aeaf70dca0c34ada9a3983475e4a0ca4c897df67614baa7e92.jpeg",
    "https://cdn.faire.com/fastly/fa903b1a51d06db2fc761e48229381fc29c3fab6a9a0577805dfe1180bc9b076.jpeg",
    "https://cdn.faire.com/fastly/df64588dd27c2166332a343624b71ca9881defd060b71513760c085822190d91.jpeg",
    "https://cdn.faire.com/fastly/172f58a4d22a181d9efdffead293960e6b2c3131a65a1a66ac0217015c59e9dd.jpeg",
  ],
  priceDollars: 14,
  description:
    "* \nPREMIUM POLYESTER/RAYON BLEND – Made with the same premium knit fabric as our beloved swaddles, this soft and stretchy gown ties at the bottom for easy diaper changes—and has room to grow.\n\n * GENEROUS SIZE – A knotted length of 25 inches and width of 8 inches. \n * \nBONUS FEATURES – Our knotted gowns feature unique snaps to make dressing a breeze, along with fold-over hand mitts to prevent scratching.\n\n * \nTRENDY, HIGH QUALITY DESIGNS – At Copper Pearl we pride ourselves on making high quality products that always look great on babies, moms, or in your nursery. Our knotted gowns are simple, modern, and sure to elevate any baby’s style.\n\n * \nPAIR PERFECTLY WITH COPPER PEARL PRODUCTS – Our trendy, newborn knotted gowns flaunt your favorite Copper Pearl prints and patterns. They are made to coordinate perfectly with products you already own and love!",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:38.624Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
